import React, { useState } from "react";
import { Button, Input, List, Space, Tag, Typography } from "antd";
import { DeleteOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { MyText } from "Components/MyText/MyText";
import { v4 as uuidv4 } from "uuid";
import { SearchSelectDebounce } from "Components/SearchSelectDebounce/SearchSelectDebounce";
import { getAllWorksToSelect } from "Api/WorksApi/helpers";
import { MyTabs } from "Components/MyTabs/MyTabs";
import { MyUploadWrapper } from "Components/MyUpload/MyUpload";
import { useDispatch } from "react-redux";
import { postEstimateFileProjectWorksThunk } from "AppStore/Slices/ProjectSlice/ProjectSlice";
export const MyWorks = ({
  disabled = false,
  groups = [],
  onChange = () => {},
  selectedWorks = [],
}) => {
  const [groupName, setGroupName] = useState("");
  const dispatch = useDispatch();
  const { Title } = Typography;
  return (
    <div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 20 }}>
        <div style={{ flex: 1 }}>
          <Title level={5}>Групи робіт</Title>

          <Space style={{ width: "100%", marginBottom: 12 }}>
            <Input
              disabled={disabled}
              placeholder="Нова група"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
            <Button
              disabled={disabled}
              type="primary"
              onClick={() => {
                if (groupName) {
                  onChange("groupCreate", { title: groupName, id: uuidv4() });
                  setGroupName("");
                }
              }}
            >
              Створити
            </Button>
          </Space>

          {groups.length ? (
            <List
              bordered
              dataSource={groups}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <a
                      onClick={() => {
                        if (disabled) return;
                        onChange("deleteGroup", item.id);
                      }}
                    >
                      <DeleteOutlined style={{ color: "red" }} />
                    </a>,
                  ]}
                >
                  {item.title}
                </List.Item>
              )}
            />
          ) : (
            ""
          )}
        </div>

        <div style={{ flex: 1 }}>
          <Title level={5}>Додати роботи</Title>

          <SearchSelectDebounce
            disabled={disabled}
            prefix={<UnorderedListOutlined />}
            placeholder="Пошук робіт..."
            customFetch={getAllWorksToSelect}
            onChange={(e) => {
              const worksIds = (Array.isArray(e) ? e : [])
                .filter(Boolean)
                .map((el) => el?.value ?? el)
                .filter(Boolean);

              const worksData = worksIds.map((work) => {
                const json = work.split("___")[0];
                const raw = JSON.parse(json);
                return raw;
              });
              onChange("addAllowedWorkType", worksData[0]);

              //         label: item.title,
              // value:
              //   JSON.stringify({
              //     code: item.code,
              //     unit: item.unit,
              //     title: item.title,
              //     allowedWorkTypeId: item.id,
              //   }) +
              //   "___" +
              //   item.id,

              // onChange("addAllowedWorkType", worksData);
              // onChange("addAllowedWorkType", e.raw);
            }}
          />

          <Space>
            <Tag color="blue">Код роботи</Tag>
            <Tag color="orange">Назва роботи</Tag>
          </Space>
          <MyText>
            <ul>
              <li>Вибираєте роботи які будуть в даному проекті.</li>
              <li>Тільки вибрані роботи потім можна буде вказати у бланку.</li>
              <li>Роботи Ви можете групувати.</li>
              <li>Також за потреби задайте планове значення до виконання.</li>
              <li>
                <MyUploadWrapper
                  disabled={disabled}
                  btnText={"Або завантажте кошторис з 1С"}
                  customRequest={(file) => {
                    dispatch(postEstimateFileProjectWorksThunk(file));
                  }}
                />
              </li>
            </ul>
          </MyText>
        </div>
      </div>

      <MyTabs
        groups={groups}
        selectedWorks={selectedWorks}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  );
};
